export const getDomainError = (domain: string): string => {
  let errorMessage: string = null;
  const domainParts: string[] = domain.split('.');
  if (domainParts.length < 2) {
    return 'domain.search.error';
  }
  const isEEDomain = domainParts[domainParts.length - 1] === 'ee';
  domainParts.forEach((domainPart) => {
    const error = getDomainPartError(domainPart, isEEDomain);
    error && (errorMessage = error);
  });
  return errorMessage;
};

const getDomainPartError = (domainPart: string, isEEDomain: boolean): string => {
  if (isEEDomain) {
    // eslint-disable-next-line no-useless-escape
    if (!/^[\-a-zšžõäöü0-9]+$/.test(domainPart)) {
      return 'domain.search.error.notAllowedCharacterEstonian';
    }
    // eslint-disable-next-line no-useless-escape
  } else if (!/^[\-a-z0-9]+$/.test(domainPart)) {
    return 'domain.search.error.notAllowedCharacter';
  }
  if (domainPart.startsWith('-') || domainPart.endsWith('-')) {
    return 'domain.search.error.hyphen';
  }
  if (domainPart.length < 2) {
    return 'domain.search.error.length';
  }
};
